import script from "./HighlightsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightsSection.vue?vue&type=script&setup=true&lang=js"

import "./HighlightsSection.vue?vue&type=style&index=0&id=ffe008cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffe008cc"]])

export default __exports__